import {
    GetNextHistory,
    GetHistoryHasNext,
    SetNextHistory,
    SetHistoryHasNext,
    AddMessageToStore,
    LocalStorage
} from '../Store'
import { Config } from "../constant";
import Axios from "axios";
import { parse } from '../model/Incoming';

export async function LoadConversationHistory() {
    const next = GetNextHistory();
    const hasNext = GetHistoryHasNext();
    if (hasNext) {
      const endpoint =
        Config.chatHistoryUrl +
        "?id=" +
        LocalStorage.get("chatRoomId") +
        (next ? "&next=" + next : "");
      try {
        const result = await Axios.get(endpoint);
        if (result.data) {
          const { list, paging } = result.data;
          console.log("Paging", paging);
          if (paging && paging.cursor && paging.cursor.next) {
            SetNextHistory(paging.cursor.next);
          } else {
            console.log("No history left");
            SetNextHistory(null);
            SetHistoryHasNext(false);
          }
          list.reverse().forEach((element) => {
            AddMessageToStore(parse(element));
          });
        }
      } catch (e) { }
    }
  }